import { openMiniCart } from "./MiniCart";
import axios from "axios";

export const addItemToCart = (productId, quantity = 1) => {
    return new Promise((resolve, reject) => {
        if (!productId) reject('No product id');

        const data = new URLSearchParams();
        data.append('product_id', productId);
        data.append('quantity', quantity);

        const addingToCartEvent = new CustomEvent('adding_to_cart', {
            detail: {
                product_id: productId
            }
        });
        document.dispatchEvent(addingToCartEvent);

        axios.post(wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'), data, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            }
        }).then(res => {
            jQuery(document.body).trigger('added_to_cart', [res.data.fragments, res.data.cart_hash]);
            window.themeNotifications({
                icon: 'success',
                iconColor: 'var(--black-leather-jacket-1)',
                title: ajax.i18n.added_to_cart,
            });
            console.log('success buy item')
            openMiniCart();

            resolve("Produkt dodany do koszyka");
        }).catch(err => {
            window.themeNotifications({
                icon: 'error',
                title: ajax.i18n.failed_add_to_cart,
            });

            const failedAddingToCartEvent = new CustomEvent('failed_adding_to_cart', {
                detail: {
                    product_id: productId
                }
            });
            document.dispatchEvent(failedAddingToCartEvent);

            reject("Nie udało się dodać produktu do koszyka");
        });
    });
}

export const initializeQuantityInput = (wrapper) => {
    const product = document.querySelector('.customProductPage');
    if (!product || !wrapper) return;

    const decrease = wrapper.querySelector('.decrease');
    const increase = wrapper.querySelector('.increase');
    const input = wrapper.querySelector('input');

    decrease.addEventListener('click', () => {
        if (input.value > 1) input.value = parseInt(input.value) - 1;

        const quantityChangeEvent = new CustomEvent('quantity-change', {
            detail: {
                quantity: input.value
            }
        });
        product.dispatchEvent(quantityChangeEvent);
    });
    increase.addEventListener('click', () => {
        if (input.value < (input.getAttribute('max') ? parseInt(input.getAttribute('max')) : 9999999)) input.value = parseInt(input.value) + 1;

        const quantityChangeEvent = new CustomEvent('quantity-change', {
            detail: {
                quantity: input.value
            }
        });
        product.dispatchEvent(quantityChangeEvent);
    });

    product.addEventListener('quantity-change', (event) => {
        input.value = event.detail.quantity;
    });
}